<template>
  <el-container>
    <el-main>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="头像">
          <el-upload
            class="avatar-uploader"
            action="/api/commons/upload/uploadimg"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.avatar" :src="form.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="form.real_name"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="form.gender" placeholder="选择性别">
            <el-option v-for="(val, key, index) in defaultInfo.gender" :key="index" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="form.birthday" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="名族">
          <el-select v-model="form.famous_family" placeholder="选择名族">
            <el-option v-for="(val, key, index) in defaultInfo.nation" :key="index" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最高学历">
          <el-select v-model="form.education" placeholder="选择学历">
            <el-option v-for="(val, key, index) in defaultInfo.education" :key="index" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="form.id_card"></el-input>
        </el-form-item>
        <el-form-item label="籍贯">
          <el-cascader
              :value="address_value"
              :options="area"
              @change="cascaderChange"></el-cascader>
        </el-form-item>
        <el-form-item label="个人标签">
          <el-input v-model="form.person_tag" placeholder="标签,标签,标签"></el-input>
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="form.weixin_id" placeholder="微信号"></el-input>
        </el-form-item>
        <el-form-item label="兴趣爱好">
          <el-select multiple v-model="form.interest" placeholder="爱好,爱好,爱好,...,...">
            <el-option v-for="(val, key, index) in defaultInfo.interest" :key="index" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业特长">
          <el-select multiple v-model="form.speciallty" placeholder="特长,特长,特长,...,...">
            <el-option v-for="(val, key, index) in defaultInfo.specialty" :key="index" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-col :span="8">
            <el-upload
              class="avatar-uploader"
              action="/api/commons/upload/uploadimg"
              :data="uploadData"
              :show-file-list="false"
              :on-success="handleCertSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="form.cert_img" :src="form.cert_img" class="avatar">
              <div v-else style="line-height: 2.4;padding: 15px 0; color: #666;">
                <p style="padding:0; margin: 0;">个人形象照</p>
                <i class="el-icon-plus avatar-uploader-icon" style="height: 20px; line-height: 20px !important;"></i>
              </div>
            </el-upload>
          </el-col>
          <el-col :span="8">
            <el-upload
              class="avatar-uploader"
              action="/api/commons/upload/uploadimg"
              :data="uploadData"
              :show-file-list="false"
              :on-success="handleCardFrontSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="form.card_front_img" :src="form.card_front_img" class="avatar">
              <div v-else style="line-height: 2.4;padding: 15px 0; color: #666;">
                <p style="padding:0; margin: 0;">身份证正面照</p>
                <i class="el-icon-plus avatar-uploader-icon" style="height: 20px; line-height: 20px !important;"></i>
              </div>
            </el-upload>
          </el-col>
          <el-col :span="8">
            <el-upload
              class="avatar-uploader"
              action="/api/commons/upload/uploadimg"
              :data="uploadData"
              :show-file-list="false"
              :on-success="handleCardBackSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="form.card_back_img" :src="form.card_back_img" class="avatar">
              <div v-else style="line-height: 2.4;padding: 15px 0; color: #666;">
                <p style="padding:0; margin: 0;">身份证反面照</p>
                <i class="el-icon-plus avatar-uploader-icon" style="height: 20px; line-height: 20px !important;"></i>
              </div>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
export default {
  name: "infoBase",
  created(){
    this.form = {
      ...this.form,
      ...this.infos,
      gender: String(this.infos.gender),
      education: String(this.infos.education),
      famous_family: String(this.infos.famous_family),
      interest: this.infos.interest?this.infos.interest.split(','):'',
      speciallty: this.infos.speciallty?this.infos.speciallty.split(','):''
    };
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  watch:{
    form:function(val){
      this.address_value = [
        String(val.birth_province_id),
        String(val.birth_city_id),
        String(val.birth_county_id)
      ];
    }
  },
  props:{
    infos: {
      type: Object,
      default: ()=>{
        return {};
      }
    }
  },
  data(){
    return {
      address_value: [],
      uploadData: {
        format: 'file',
        file_type: 'avatar'
      },
      form: {
        avatar: '',
        real_name: '',
        gender: '',
        id_card: '',
        education: '',
        famous_family: '',
        birth_province_id: '',
        birth_city_id: '',
        birth_county_id: '',
        person_tag: '',
        birthday: '',
        weixin_id: '',
        interest: '',
        speciallty: '',
        cert_img: '',
        card_front_img: '',
        card_back_img: ''
      }
    };
  },
  methods: {
    cascaderChange(value){
      this.birth_province_id = value[0];
      this.birth_city_id = value[1];
      this.birth_county_id = value[2];
    },
    onSubmit() {
      //过滤标签的逗号
      this.form.person_tag = this.form.person_tag.split('，').join(',');
      let params = {
        ...this.form
      };
      delete params['assistant_list'];
      delete params['commerce_position_name'];
      delete params['interest_list'];
      delete params['speciallty_list'];
      for (let key in params) {
        params['row['+key+']'] = params[key];
        delete params[key];
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      $http.post("/api/member/member/editMyBaseInfo", params)
        .then(res=>{
          console.log(res);
          if (res.data.code===1) {
            this.$emit('success');
          } else {
            this.$message.error(res.data.msg);
          }
          loading.close();
        });
    },
    handleAvatarSuccess(res) {
      this.form.avatar = res.data;
    },
    handleCertSuccess(res) {
      this.form.cert_img = res.data;
    },
    handleCardFrontSuccess(res) {
      this.form.card_front_img = res.data;
    },
    handleCardBackSuccess(res) {
      this.form.card_back_img = res.data;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    cancel(){
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="less">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px !important;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>

